// #region Enums

export const enum ReportingQueryCacheKey {
  GetSalesReport = 'GetSalesReport',
  GetPackageSalesReport = 'GetPackageSalesReport',
  GetQueriesReport = 'GetQueriesReport',
  GetAdditionalServiceReport = 'GetAdditionalServiceReport',
  GetCampaignReport = 'GetCampaignReport',
}

// #endregion

// ##region Types

export interface SaleReportRowResponse {
  date: string;
  count: string;
  amount: string;
}

export interface SaleReportResponse {
  sales: SaleReportRowResponse[];
  totalSalesCount: number;
  totalSalesAmount: number;
}

export interface SaleReportAdminResponse extends SaleReportResponse {
  royaltiAmount?: number;
}

export interface AdminSaleReportGraphData {
  dateLabels: string[];
  saleReportLineData: number[];
  countReportBarData: number[];
}

export interface ExpertisePackageReportRowResponse {
  id: number;
  name: string;
}

export interface ExpertisePackageReportResponse {
  expertisePackage: ExpertisePackageReportRowResponse;
  count: number;
}

export interface AdminPackageSaleReportGraphData {
  packageLabels: string[];
  packageSales: number[];
}

export interface QueriesReportKmRowResponse {
  date: string;
  count: string;
}

export interface QueriesReportTramerRowResponse {
  date: string;
  count: string;
}

export interface QueriesReportResponse {
  kilometerQueries: QueriesReportKmRowResponse[];
  tramerQueries: QueriesReportTramerRowResponse[];
  tramer360Queries: QueriesReportTramerRowResponse[];
}

export interface QueriesReportAdminResponse extends QueriesReportResponse {
  totalQueriesAmount: number;
  totalQueriesCount: number;
  totalTramerQueriesCount?: number;
  totalTramerQueriesAmount?: number;
  totalKilometerQueriesCount?: number;
  totalKilometerQueriesAmount?: number;
  totalTramer360QueriesCount: number;
  totalTramer360QueriesAmount: number;
}

export interface AdminQueriesReportGraphData {
  dateLabels: string[];
  tramerReportBarData: number[];
  kmReportBarData: number[];
  totalCountReportLineData: number[];
}

export interface CustomerQueriesReportDto {
  date: string;
  count: string;
  amount: string;
}

export interface ExtraPackagesReportResponse {
  roadAssistanceQueries: CustomerQueriesReportDto[];
  usedCarProtectionQueries: CustomerQueriesReportDto[];
}

export interface ExtraPackagesReportAdminResponse extends ExtraPackagesReportResponse {
  totalRoadAssistanceCount: number;
  totalRoadAssistanceAmount: number;
  totalUsedCarProtectionCount: number;
  totalUsedCarProtectionAmount: number;
  totalCount: number;
  totalAmount: number;
}

export interface GetFinancialSummaryReportRequest {
  expertisePointId?: number;
  startDate: string;
  endDate: string;
}

export interface FinancialSummaryItemDto {
  amount: number;
  count: number;
}

export interface FinancialSummaryReportResponse {
  initialBalance: number;
  loadedBalance: number;
  totalBalance: number;
  royaltyAmount: number;
  damageQuery: FinancialSummaryItemDto;
  tramer360Query: FinancialSummaryItemDto;
  kilometerQuery: FinancialSummaryItemDto;
  roadAssistancePackage: FinancialSummaryItemDto;
  secondHandVehicleProtectionPackage: FinancialSummaryItemDto;
  totalExpenses: number;
  finalBalance: number;
  kaleCard: FinancialSummaryItemDto;
  expertiseAmount: FinancialSummaryItemDto;
}

export interface SalesReportDataResponse {
  date: string;
  expertisePointName: string;
  plate: string;
  customerName: string;
  packageGroupName?: string;
  packageName: string;
  amount: number;
  royalty: number;
  listPrice: number;
  discountAmount: number;
  groupType?: number;
  campaignInfo?: string;
}

export interface QueriesReportDataResponse {
  date: string;

  expertisePointName: string;

  plate?: string;

  packageGroupName?: string;

  packageName?: string;

  queryName: string;

  amount: number;
}

export interface PackageSalesReportDataResponse {
  expertisePointName: string;

  packageGroupName?: string;

  packageName: string;

  packageCount: number;
}

export interface CustomerAdditionalServiceReportDto {
  date: string;
  count: number;
  productId: number;
  productName: string;
  amount: number;
}

export interface AdditionalServiceReportResponse {
  totalCount: number;
  totalAmount: number;
  services: CustomerAdditionalServiceReportDto[];
}

export interface AdditionalServiceReportAdminResponse extends AdditionalServiceReportResponse {
  royaltiAmount?: number;
}

export interface AdditionalServiceReportDataResponse {
  date: string;
  expertisePointName: string;
  plate: string;
  customerName: string;
  packageGroupName: string;
  packageName: string;
  productName: string;
  amount: number;
  count: number;
}

// Campaign Report Types
export interface CampaignReportItem {
  id: number;
  name: string;
  discountRate: string;
  discountRateStr: string;
  endDate: string;
  totalAssignmentCount: number;
  totalUnusedCount: number;
  totalUsedCount: number;
}

export interface CampaignListReportResponse {
  campaigns: CampaignReportItem[];
}

export interface CampaignUsedDetailReportResponse {
  phoneNumber: string;
  usedByPhoneNumberCount: number;
  assignmentDate: Date;
  campaignId: number;
  campaignName: string;
  campaignCode: string;
  discountRate: number;
  discountRateStr: string;
  startDate: Date;
  endDate: Date;
  assignmentCount: number;
  unusedCount: number;
  totalUsageLimit?: number;
  perUserUsageLimit?: number;
}

// #endregion
